<template>
  <div class='reportList'>
     <el-tabs v-model="activeName2" type="card" @tab-click="handleClick">
      <el-tab-pane label="全部报告" name="allList"></el-tab-pane>
      <el-tab-pane label="待审核" name="waitList"></el-tab-pane>
      <el-tab-pane label="审核中" name="startList"></el-tab-pane>
      <el-tab-pane label="已审核" name="endList"></el-tab-pane>
    </el-tabs>
    <el-row class='reportList-nav' id='reportListnav'>
      <el-col :class="{'toggleSearchType':isActive}">
        <el-form :inline="true" :model="search" ref="search" size='mini' class="demo-form-inline">
          <el-row class='nav-top'>
            <el-form-item label="" prop="patientName">
              <el-input v-model="search.patientName" placeholder="患者姓名"></el-input>
            </el-form-item>
            <el-form-item label="" prop="patientNo">
              <el-input v-model="search.patientNo" placeholder="影像号"></el-input>
            </el-form-item>
            <el-form-item label="" prop="RegNo">
              <el-input v-model="search.RegNo" placeholder="登记单号"></el-input>
            </el-form-item>
            <el-form-item style='width:7%;min-width: 60px;'>
              <el-button type="primary" icon="el-icon-search" @click="onSubmit(1)">查询</el-button>
            </el-form-item>
            <el-form-item  style='width:7%;min-width: 60px;'>
              <el-button type="success" @click="resetForm" icon="el-icon-circle-close-outline" >清空</el-button>
            </el-form-item>
            <el-form-item  style='width:7%;min-width: 60px;'>
              <el-button  @click="excel" size='mini' style="width:100%;" type="primary">导出Excel</el-button>
            </el-form-item>

            <el-form-item style="float:right;margin-bottom:0px;margin-right:0px;width:5%;">
              <el-button style="font-size:18px;width:50px;color:#3A4A64;font-size:21px;" type="text" @click="toggleClick"><i :class="{'is-active':isActive}" class="hamburger el-icon-arrow-down"></i></el-button>
            </el-form-item>
          </el-row>
          <div  class="toggleSearch" >
            <el-row  class='nav-top'>
              <el-col>
                <el-form-item label="" prop="SrcHospitalName">
                  <el-input v-model="search.SrcHospitalName" placeholder='检查医院'></el-input>
                </el-form-item>
                <el-form-item label=""  prop="PatientType">
                  <el-select v-model="search.PatientType" placeholder="患者来源">
                    <el-option  v-for='item in dict.patientSource' :key='item.id' :label='item.dictName' :value='item.dictName'></el-option>
                  </el-select>
                </el-form-item>
                <!-- <el-form-item label="" prop="SubmitterName">
                  <el-input v-model="search.SubmitterName" placeholder="诊断医生"></el-input>
                </el-form-item> -->
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <el-form-item label="检查时间" >
                  <el-radio-group v-model="timeType" >
                    <el-radio-button v-for='item in getTime' :key='item.Value' :label='item.Value'  >{{item.Text}}</el-radio-button>
                    <el-radio-button label='4'  class="nav-time">
                      <el-date-picker  v-model="search.DateArray"  format="yyyy-MM-dd" value-format="yyyy-MM-dd"  type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change='changeTime'></el-date-picker>
                    </el-radio-button>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <el-form-item label="设备类型">
                  <el-radio-group v-model="search.Modality" @change='onSubmit(1)'>
                    <el-radio-button  label='' >全部</el-radio-button>
                    <el-radio-button  v-for='item in checkList.checkType' :key='item.name' :label='item.name' >{{item.name}}</el-radio-button>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <el-form-item label="检查部位" >
                  <el-radio-group v-model="search.bodyPart" @change='onSubmit(1)'>
                    <el-radio-button  label='' >全部</el-radio-button>
                    <el-radio-button  v-for='item in checkList.checkBody' :key='item.name' :label='item.name' >{{item.name}}</el-radio-button>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-form>
      </el-col>
    </el-row>
     <div class="reportList-table" >
        <el-table v-if='writeReportList.length > 0' stripe :data='writeReportList' size='mini' v-loading="tableloading"   style='width: 100%'   @row-dblclick='dbTalble' >
            <!-- <el-table-column prop='modalityName' label='设备类型' min-width='120px'>
              <template slot-scope="scope">
                <div class="name-wrapper">
                  <span style='background:#FF8C8C;' v-if='scope.row.modalityName'>{{ scope.row.modalityName }}</span>
                  <div v-else></div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop='checkingItems' label='检查项目'  min-width='180px' >
                <template slot-scope="scope">
                  <el-popover trigger="hover" placement="top">
                      {{ scope.row.checkingItems }}
                    <div slot="reference" class="name-wrapper">
                      <span  v-if='scope.row.checkingItems'>{{ scope.row.checkingItems | checkingItems}}</span>
                      <div v-else></div>
                    </div>
                  </el-popover>
                </template>
            </el-table-column> -->

            <el-table-column :fixed="index === 0" v-for='(col, index) in headerList' :show-overflow-tooltip = 'true' :key='index' :min-width="col.width" :prop='col.prop' :label='col.label' v-if='col.isShow'>
              <template slot-scope="scope">
                <span @click="openAi(scope.row.aiResultWebUrl)" v-if="index === 0 && scope.row.hasAIResult" style="font-size:20px;">
                  <svg-icon  icon-class='A_I'></svg-icon>
                </span>
                <el-popover trigger="hover" placement="top" v-if="col.prop === 'checkingItems'">
                  {{ scope.row[col.prop] | checkingItems}}
                  <div slot="reference" class="name-wrapper">
                    <span style="background: #ff9d60;" v-if='scope.row[col.prop]'>{{ scope.row[col.prop] | checkingItems}}</span>
                    <div v-else></div>
                  </div>
                </el-popover>
                <el-popover trigger="hover" placement="top" v-else-if="col.prop === 'modalityName'">
                  {{ scope.row[col.prop]}}
                  <div slot="reference" class="name-wrapper">
                    <span style="background: #FF8C8C;" v-if='scope.row[col.prop]'>{{ scope.row[col.prop]}}</span>
                    <div v-else></div>
                  </div>
                </el-popover>
                <el-popover trigger="hover" placement="top" v-else-if="col.prop === 'bodyParts'">
                  {{ scope.row[col.prop]}}
                  <div slot="reference" class="name-wrapper">
                    <span style="background: #49C1E4;" v-if='scope.row[col.prop]'>{{ scope.row[col.prop]}}</span>
                    <div v-else></div>
                  </div>
                </el-popover>
                <span v-else>
                  {{scope.row[col.prop]}}
                </span>
              </template>
            </el-table-column>
            <!-- <el-table-column prop='patientName' label='姓名' width='100px'> </el-table-column>
            <el-table-column prop='sexName' label='性别' width='80px'> </el-table-column>
            <el-table-column prop='age' label='年龄' width='80px'> </el-table-column>
            <el-table-column prop='statusName' label='医疗状态' width='110px'></el-table-column>
            <el-table-column prop='patientNo' label='影像号' width='180px'> </el-table-column>
            <el-table-column prop='patientType' label='患者来源' width='110px'> </el-table-column>
            <el-table-column prop='submitterName' label='诊断医生' width='130px'> </el-table-column>
            <el-table-column prop='regNo' label='登记单号' width='180px'> </el-table-column>
            <el-table-column prop='register' label='登记医生' width='110px'> </el-table-column>
            <el-table-column prop='regDt' label='登记时间' min-width="180px"> </el-table-column> -->
            <el-table-column prop='' label='功能' width='190px' size='mini' fixed="right">
              <template slot-scope="scope">
                  <el-tooltip class="item" effect="dark" content="报告审核" placement="top">
                    <el-button style="background:#44cc79;color:#fff;border:none;float:left;margin-right:10px;" type="" size='mini' circle @click='dbTalble(scope.row)'><svg-icon  icon-class='writereport'></svg-icon></el-button>
                  </el-tooltip>
                  <el-tooltip class="item" effect="dark" content="查看影像" placement="top" >
                    <el-button style="background:#5AB1EF;color:#fff;border:none;float:left;margin-right:10px;" type="" size='mini' circle @click='pacsImg(scope.row.webPacsUrl)' ><svg-icon style='color:#fff;' icon-class='preview_1'></svg-icon></el-button>
                  </el-tooltip>
                  <template v-if="userId === scope.row.firstApprover">
                    <el-tooltip class="item" effect="dark" content="审核召回" placement="top" v-if='scope.row.status === 100'>
                      <el-button style="background:#FF6E6E;color:#fff;border:none;float:left;margin-right:10px;" type="" size='mini' circle @click='RecallReport(scope.row,"您已成功召回报告")'><svg-icon  icon-class='reason'></svg-icon></el-button>
                    </el-tooltip>
                  </template>
                  <!-- <el-tooltip class="item" effect="dark" content="删除检查" placement="top">
                    <el-button
                      style="background:#ff8c8c;color:#fff;border:none;"
                      type
                      size="mini"
                      circle
                      @click="DeletePerform(scope.row)"
                    >
                      <i class="el-icon-delete"></i>
                    </el-button>
                  </el-tooltip> -->
                  <!-- <template v-if="scope.row.sendType !== 2">
                    <el-tooltip class="item" effect="dark" content="远程会诊" placement="top" v-if="scope.row.statusName === '待审核' ">
                      <el-button
                        style="background:#8470F2;color:#fff;border:none;float:left;margin-right:10px;"
                        type
                        size="mini"
                        circle
                        @click="GetDiagnosticDeparts(scope.row)"
                      >
                        <svg-icon icon-class="consultation"></svg-icon>
                      </el-button>
                    </el-tooltip>
                  </template> -->

                <!--
                <el-tooltip class="item" effect="dark" content="分诊" placement="top">
                  <el-button style="background:#28E1BD;color:#fff;border:none;" type="" size='mini' circle><svg-icon  icon-class='triage'></svg-icon></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="退回原因" placement="top">
                  <el-button style="background:#FFB22D;color:#fff;border:none;" type="" size='mini' circle><svg-icon  icon-class='returnReason'></svg-icon></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="退回" placement="top">
                  <el-button style="background:#FF6E6E;color:#fff;border:none;" type="" size='mini' circle><svg-icon  icon-class='reason'></svg-icon></el-button>
                </el-tooltip> -->
              </template>
            </el-table-column>
        </el-table>
        <div v-else style="width:100%;text-align:center;background:#f8f8f8;">
          <img src="../../assets/empty_01.png" alt="" style="height: calc(100vh - 353px);width: auto;"  />
        </div>
    </div>
    <el-row style="text-align: center;" v-if='writeReportList.length > 0'>
      <div class="block">
        <el-pagination
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 40, 80, 100]"
          :page-size="search.PageCount"
          layout="total, sizes, prev, pager, next, jumper"
          :total="ReportListtotalCount">
        </el-pagination>
      </div>
    </el-row>
    <!-- <el-dialog
      title="远程会诊"
      :visible.sync="dialogTableVisible"
      width="700px"
      custom-class="revisitDialog"
      ref="dialog"
      @close="close"
    >
      <el-row style="margin-top:20px;border-top:1px solid #397EE3;">
        <el-table
          :data="DiaDeparts"
          stripe
          max-height="300px"
          size="mini"
          height="250"
          v-loading="hospListloading"
          highlight-current-row @current-change="handleCurrentChanges"
        >
          <el-table-column property="hospName" label="医院名称"></el-table-column>
          <el-table-column property="departName" label="科室名称"></el-table-column>
        </el-table>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size='mini' style="" @click="consultation(fillInfors)"> 确 定 </el-button>
      </div>
    </el-dialog> -->

<el-dialog
  title="影像地址"
  :visible.sync="dialogVisible"
  width="30%"
  >
  <div class="popupImgUrl">
    <a href="javascript:;" v-for="(item,index) in imagesUrl" :key="index" @click="openAi(item)">地址{{index+1}}</a>
  </div>
  <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">关闭</el-button>

  </span>
</el-dialog>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { formatDate } from '@/utils/index.js'
import common from '@/utils/common.js'
export default {
  name: 'Diagnostic',
  data() {
    return {
      dialogVisible: false,
      imagesUrl: [],
      dialogTableVisible: false,
      hospListloading: false,
      fillInfors: '',
      tableloading: false,
      tableHeight: '100px',
      getTime: common.SettingsTime.value,
      getqueryType: common.SettingsqueryType.value,
      ReportList: [],
      timeType: 0,
      isActive: false,
      navHeight: 102,
      activeName2: 'allList',
      currentPage: 1
    }
  },
  beforeMount() {
    window.addEventListener('resize', this.resizeHeight)
  },
  mounted() {

  },
  created() {
    // this.search.DateArray = [formatDate(new Date(), 'yyyy-MM-dd'), formatDate(new Date(), 'yyyy-MM-dd')]
    if (new Date(this.search.DateArray[1]).getTime() / (24 * 3600 * 1000) - new Date(this.search.DateArray[0]).getTime() / (24 * 3600 * 1000) === 0) {
      this.timeType = 0
    } else if (new Date(this.search.DateArray[1]).getTime() / (24 * 3600 * 1000) - new Date(this.search.DateArray[0]).getTime() / (24 * 3600 * 1000) === 3) {
      this.timeType = 2
    } else if (new Date(this.search.DateArray[1]).getTime() / (24 * 3600 * 1000) - new Date(this.search.DateArray[0]).getTime() / (24 * 3600 * 1000) === 7) {
      this.timeType = 3
    } else {
      this.timeType = 4
    }
    this.handleClick(this.activeName2)
    this.getChecktype()
    this.resizeHeight()
  },
  computed: {
    ...mapGetters([
      'writeReportList',
      'dict',
      'userId',
      'ReportVariable',
      'lock',
      'ReportListtotalCount',
      'checkList',
      'currentUserRoleDepart',
      'headerList',
      'DiaDeparts',
      'search'
    ]),
    newModality() {
      return this.search.Modality
    }
  },
  methods: {
    close() {
      this.ConHospList = []
    },
    DeletePerform(datas) {
      this.$store
        .dispatch('DeletePerform', { performId: datas.performId })
        .then(() => {
          this.$message({
            message: '成功删除检查！',
            type: 'success'
          })
          this.onSubmit(1)
        })
        .catch(() => {
          this.$message({
            message: '删除检查失败，请重试！',
            type: 'warning'
          })
        })
    },
    handleCurrentChanges(val) {
      this.fillInfors = val
    },
    handleSizeChange(val) {
      this.search.PageCount = val
      this.onSubmit(1)
    },
    handleCurrentChange(val) {
      this.onSubmit(val)
    },
    toggleClick: function() {
      this.isActive = !this.isActive
    },
    resizeHeight: function() {
      this.tableHeight = document.documentElement.clientHeight - this.navHeight - 290 + 'px'
    },
    checkTimeType(type) {
      if (type === 0) {
        this.search.DateArray = [formatDate(new Date(), 'yyyy-MM-dd'), formatDate(new Date(), 'yyyy-MM-dd')]
      }
      if (type === 1) {
        this.search.DateArray = [formatDate(new Date(new Date() - 3600 * 1000 * 24), 'yyyy-MM-dd'), formatDate(new Date(), 'yyyy-MM-dd')]
      }
      if (type === 2) {
        this.search.DateArray = [formatDate(new Date(new Date() - 3600 * 1000 * 24 * 3), 'yyyy-MM-dd'), formatDate(new Date(), 'yyyy-MM-dd')]
      }
      if (type === 3) {
        this.search.DateArray = [formatDate(new Date(new Date() - 3600 * 1000 * 24 * 7), 'yyyy-MM-dd'), formatDate(new Date(), 'yyyy-MM-dd')]
      }
      if (type === 4) {
        this.search.DateArray = this.search.DateArray
      }
      this.onSubmit(1)
    },
    // GetDiagnosticDeparts(row) {
    //   this.consultations.procedureIds = row.procedureIds
    //   this.consultations.departId = row.srcDeptId
    //   this.consultations.hospId = row.srcHospitalId
    //   this.dialogTableVisible = true
    //   this.$store
    //     .dispatch('GetDiagnosticDeparts')
    //     .then(() => {
    //       // 获取当前科室的可分配科室
    //     })
    //     .catch(() => {})
    // },
    excel() {
      var days = new Date(this.search.DateArray[1]).getTime() - new Date(this.search.DateArray[0]).getTime()
      var time = parseInt(days / (1000 * 60 * 60 * 24))
      if (time > 31) {
        this.$message({
          message: '您所选的时间段大于一个月，不能导出Excel，请重新选择！',
          type: 'warning'
        })
      } else {
        // var date = new Date(this.search.DateArray[0])
        // var Y = date.getFullYear() + '-'
        // var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
        // var D = date.getDate()
        // var startDate = Y + M + D
        // var date1 = new Date(this.search.DateArray[1])
        // var Y1 = date1.getFullYear() + '-'
        // var M1 = (date1.getMonth() + 1 < 10 ? '0' + (date1.getMonth() + 1) : date1.getMonth() + 1) + '-'
        // var D1 = date1.getDate()
        // var endDate = Y1 + M1 + D1
        var str = JSON.stringify(this.search)
        window.open(this.$getCfg('VUE_APP_BASE_API') + '/Statistics/GetRegistrationInfoSheet?query=' + str + '&fileName=', '_blank')
      }
    },
    GetTableHeaderConfigs() {
      this.$store.dispatch('GetTableHeaderConfigs', { departId: this.currentUserRoleDepart.departId, type: 4 }).then(() => {
      }).catch(() => {
        this.$message({ message: '获取表头配置失败，请重新获取', type: 'warning' })
      })
    },
    getBody(value) {
      if (value) {
        var temp = ''
        for (let i = 0; i < this.checkList.checkType.length; i++) {
          if (this.checkList.checkType[i].name === value) {
            temp = this.checkList.checkType[i].modality
            break
          }
        }
        this.$store.dispatch('getcheckBody', { departId: this.currentUserRoleDepart.departId, modality: temp }).then(() => { // 提交登记
        }).catch(() => {
          this.$message({ message: '获取检查部位失败，请重新获取', type: 'warning' })
        })
      }
    },
    getChecktype() {
      this.$store.dispatch('getcheckType', { departId: this.currentUserRoleDepart.departId }).then(() => { // 提交登记

      }).catch(() => {
        this.$message({ message: '获取设备类型失败，请重新获取', type: 'warning' })
      })
    },
    handleClick(tab, event) {
      if (tab.name === 'allList') {
        this.search.CompleteStatus = 50
      }
      if (tab.name === 'waitList') {
        this.search.CompleteStatus = 25
      }
      if (tab.name === 'startList') {
        this.search.CompleteStatus = 30
      }
      if (tab.name === 'endList') {
        this.search.CompleteStatus = 40
      }
      this.onSubmit(1)
    },
    onSubmit(val) {
      this.search.PageIndex = val
      this.currentPage = val
      this.table = true
      this.tableloading = true
      this.$store
        .dispatch('GetReportList', this.search)
        .then(() => {
          for (var i = 0; i < this.writeReportList.length; i++) {
            if (this.writeReportList[i].printedCount === 0) {
              this.writeReportList[i].printedCount = '未打印'
            } else {
              this.writeReportList[i].printedCount = '已打印'
            }
          }
          this.GetTableHeaderConfigs()
          this.loading = false
          this.tableloading = false
        })
        .catch(() => {
          this.loading = false
          this.tableloading = false
        })
    },
    RecallReport: function(datas, msg) {
      this.$confirm('您是否确认召回已审核的报告！', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.CreateOrUpdateReport = {// 保存更新报告
          reportId: datas.reportId,
          performId: datas.performId,
          regId: datas.regId,
          wys: datas.wys,
          wyg: datas.wyg,
          status: 90,
          isEmergency: datas.isEmergency,
          isPositive: datas.isPositive,
          procedureIds: datas.procedureIds,
          isDeleted: false,
          departId: datas.departId,
          qcScore: datas.qcScore
        }
        this.$store
          .dispatch('RecallReport', this.CreateOrUpdateReport)
          .then(() => {
            this.$message({ message: msg, type: 'success' })
            this.onSubmit(1)
          })
          .catch(() => {})
      }).catch(() => {
        this.$message({
          type: 'success',
          message: '已取消'
        })
      })
    },
    resetForm() {
      this.$refs['search'].resetFields()
      this.search.Modality = ''
      this.search.bodyPart = ''
    },
    BeginApproveReport: function(row) { // 初次保存状态为50/80时
      var CreateOrUpdateReport = {// 保存更新报告
        reportId: row.reportId,
        performId: row.performId,
        regId: row.regId,
        wys: row.wys,
        wyg: row.wyg,
        status: row.status,
        isEmergency: row.isEmergency,
        isPositive: row.isPositive,
        procedureIds: row.procedureIds,
        isDeleted: false,
        departId: row.departId,
        qcScore: row.qcScore
      }
      this.$store
        .dispatch('BeginApproveReport', CreateOrUpdateReport)
        .then(() => {
        })
        .catch(() => {
        })
    },
    dbTalble: function(row) {
      this.$store
        .dispatch('getLock', { procedureId: row.procedureId, departId: this.currentUserRoleDepart.departId })
        .then(() => {
          if (this.lock.data) {
            if (row.status === 80) {
              sessionStorage.setItem('setReportVariable', JSON.stringify({ procedureId: row.procedureId, type: '2' })) // 添加到sessionStorage
              this.BeginApproveReport(row)
              this.$store.dispatch('getReportVariable').then(() => {})
              this.$router.push({ path: '/writereport' })
              this.$message({ message: '操作成功', type: 'success' })
            } else {
              sessionStorage.setItem('setReportVariable', JSON.stringify({ procedureId: row.procedureId, type: '2' })) // 添加到sessionStorage
              this.$store.dispatch('getReportVariable').then(() => {})
              this.$router.push({ path: '/writereport' })
              this.$message({ message: '操作成功', type: 'success' })
            }
          } else {
            this.$message({ message: this.lock.message, type: 'success' })
          }
        }).catch(() => {})
    },
    changeTime: function() {
      this.timeType = 4
    },
    pacsImg: function(url) {
      window.open(url, 'pacsImg', 'top=0, left=0, toolbar=no, menubar=no, scrollbars=yes, resizable=no, location=no, status=no, channelmode=yes, fullscreen=yes')
    },
    openAi(url) {
      if (url) {
        var Website = url.split(',')
        if (Website.length === 1) {
          window.open(Website[0], 'ai', 'top=0, left=0, toolbar=no, menubar=no, scrollbars=yes, resizable=no, location=no, status=no, channelmode=yes, fullscreen=yes')
        } else {
          this.dialogVisible = true
          this.imagesUrl = Website
        }
      }
    }
  },
  watch: {
    search: {
      handler: function(newVal, oldVal) {
        this.$store.dispatch('GetSearch', newVal)
      },
      deep: true
    },
    $route() {
      this.$store.dispatch('resetdiagnostic')
    },
    newModality(val) {
      this.search.bodyPart = ''
      this.getBody(this.search.Modality)
    },
    timeType(type) {
      this.checkTimeType(type)
    }
  },
  filters: {
    checkingItems(datas) {
      if (datas) {
        if (datas.length > 11) {
          datas = datas.slice(0, 10) + '…'
        }
        return datas
      } else {
        return ''
      }
    }
  }

}

</script>
<style rel='stylesheet/scss' lang='scss' scoped>
  .reportList{
    height: 100%;
    overflow-y: auto;
    .el-tabs{
      padding: 0px 20px;
      margin-top: 20px;
    }
    .reportList-nav{
      height: auto;
      background: #f8f8f8;
      margin:0px 20px 20px 20px;
      padding: 10px;
      .el-form-item{
        margin-bottom: 10px;
      }
      // .el-checkbox-button, .el-checkbox-button__inner{
      //   margin-right: 10px;
      // }

    }
    .reportList-table{
      border-top: 2px solid #ddd;
      background: #f3f5f9;
      margin:20px;
    }
    .hamburger {
      width: 21px;
      transform: rotate(0deg);
      transition: .38s;
      transform-origin: 50% 50%;
    }
    .hamburger.is-active {
      transform: rotate(180deg);
    }
    .toggleSearch{
      height: 0px;
      -webkit-transition: height .28s;
      transition: height .28s;
      overflow: hidden;
    }
    .toggleSearchType .toggleSearch{
      height: 150px;
      -webkit-transition: height .28s;
      transition: height .28s;
      overflow: hidden;
    }
    .name-wrapper{
      height: 23px;
      span{
        background: #FF9D60;
        color:#fff;
        padding: 4px 5px;
        border-radius: 3px;
        width: 100%;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
    }
    .nav-top{
      .el-form-item{
        width: 12.5%;
      }
    }
  }
  .popupImgUrl{display: flex;}
.popupImgUrl a{margin: 20px 20px 20px 0; display: block; }
.popupImgUrl a:hover{color: #397EE3}
</style>
